import { ChangeEvent, HTMLProps, Ref, forwardRef } from 'react'

import Button from '@/components/Button'
import Icon from '@/components/Icon'
import Input from '@/components/Input'

interface CountInputProps extends HTMLProps<HTMLInputElement> {
  suffix: string
  min?: number | string
  max?: number | string
  step?: number
  disabled?: boolean
}

const CountInput = (
  {
    name,
    value,
    suffix,
    disabled,
    onChange,
    min,
    max,
    step = 1
  }: CountInputProps,
  ref: Ref<HTMLInputElement>
) => {
  const handleOnChange = (value: number) => {
    if (onChange) {
      onChange({
        target: { value, name }
      } as unknown as ChangeEvent<HTMLInputElement>)
    }
  }

  const stepValue = (sign: number) => {
    const currentValue = Number(value) || 0
    const newValue =
      currentValue % step === 0
        ? currentValue + sign * step
        : sign > 0
        ? Math.ceil(currentValue / step) * step
        : Math.floor(currentValue / step) * step
    if (
      (max !== undefined && sign > 0 && newValue > Number(max)) ||
      (min !== undefined && sign < 0 && newValue < Number(min))
    ) {
      return
    }

    handleOnChange(newValue)
  }

  return (
    <div className="flex gap-2">
      <Button
        className="w-fit min-w-10 !p-[7px]"
        disabled={disabled}
        onClick={() => stepValue(-1)}
        tag="div"
        variant="secondary"
      >
        <Icon className="h-5 w-5" name="minus-20" />
      </Button>
      <Input
        className="min-h-10 !py-1.5"
        type="number"
        disabled={disabled}
        inputMode="decimal"
        placeholder="0"
        ref={ref}
        step={step}
        suffix={suffix}
        value={!!value ? value : ''}
        onChange={(event) =>
          handleOnChange(Number((event.target as HTMLInputElement).value))
        }
      />
      <Button
        className="w-fit min-w-10 !p-[7px]"
        disabled={disabled}
        onClick={() => stepValue(1)}
        tag="div"
        variant="secondary"
      >
        <Icon className="h-5 w-5 text-primary-600" name="plus-20" />
      </Button>
    </div>
  )
}

export default forwardRef<HTMLInputElement, CountInputProps>(CountInput)
